import { render } from "./LocationSelector.vue?vue&type=template&id=22618da9&scoped=true"
import script from "./LocationSelector.vue?vue&type=script&lang=js"
export * from "./LocationSelector.vue?vue&type=script&lang=js"

import "./LocationSelector.vue?vue&type=style&index=0&id=22618da9&lang=scss&scoped=true"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22618da9"]])

export default __exports__
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerDots});
